import AnchorLink from "./_anchorlink";
import ToggleContainer from "./_toggle-container";
const anchorLink = new AnchorLink();
const toggleContainer = new ToggleContainer('.js-accordion', '.js-accordion-trigger', 'is-active');
// const linkCurrent = new LinkCurrent();
toggleContainer.init();
